import ScheduleRouter from "./router/schedule-router";

export default [ScheduleRouter];
